const DownloadType = {
  DOCX: 0,
  HTML: 1,
  RTF: 2,
  CLIPBOARD: 3,
};

export { DownloadType };
